/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M446.513 355.947h.282m-380.385 0h-.225.225m16.078 16.416h347.75v-19.148c-34.719-9.658-57.92-43.307-66.086-96.666-2.704-17.542-2.788-35-2.9-51.867-.198-29.312-.367-56.991-14.39-80.193-13.881-23.034-37.337-41.336-59.722-46.602h-.028l-3.774-.9c-9.545-2.282-16.247-10.785-16.247-20.556 0-7.237-4.927-13.319-10.728-13.319-5.8 0-10.728 6.082-10.728 13.319 0 9.77-6.702 18.274-16.247 20.555l-3.773.901c-15.797 3.717-33.34 14.755-46.996 29.566-25.652 27.876-26.159 59.02-26.834 98.468-.17 10.362-.338 20.865-.986 31.509-4.871 79.912-37 108.042-68.31 116.039m216.958 74.213c11.658 0 21.119 9.46 21.119 21.118 0 35.394-28.777 64.2-64.2 64.2s-64.2-28.806-64.2-64.2c0-11.657 9.461-21.118 21.118-21.118 11.658 0 21.119 9.46 21.119 21.118 0 12.108 9.827 21.963 21.963 21.963 12.136 0 21.963-9.855 21.963-21.963 0-11.657 9.461-21.118 21.118-21.118zM256.363.875c23.625 0 43.701 16.304 50.487 38.774 29.904 10.137 58.4 33.536 76.195 63.017 19.993 33.17 20.218 68.03 20.443 101.763.113 16.05.197 31.227 2.422 45.728 4.28 28.046 15.318 61.835 43.307 63.637 13.065.845 23.258 11.658 23.258 24.61v51.36c0 13.685-11.15 24.835-24.835 24.835H65.087c-13.685 0-24.836-11.15-24.836-24.835v-51.332c0-13.065 10.306-23.906 23.456-24.638 10.925-.676 40.266-2.478 44.912-78.926.62-10.025.76-19.908.929-29.65.732-42.604 1.436-86.67 38.013-126.373 16.726-18.134 37.506-32.044 58.287-39.168C212.634 17.207 232.71.875 256.363.875z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconNotifications = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconNotifications.defaultProps = {
  theme,
};
IconNotifications.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconNotifications.displayName = 'IconNotifications';
export { IconNotifications };
